// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"d553f78e","453":"17bc1923","581":"7a0cde15","905":"1105652f"}[chunkId] + ".chunk.js";
};